import { Button } from './ui/button';
import { ChevronDown } from 'lucide-react';
import { ParticleAnimation, FloatingParticles } from './ParticleAnimation';
import digitechLogo from '/logo.png';

export function HeroSection() {
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  // Static company data
  const companyData = {
    name: 'PT.Digital Robotik Indonesia',
    tagline: 'Drive to the Future',
    // description: 'Part of Perahu Group',
    logo_url: digitechLogo
  };

  return (
    <section id="home" className="min-h-screen relative overflow-hidden flex items-center justify-center">
      {/* Background Animations */}
      <ParticleAnimation 
        className="opacity-60"
        particleCount={120}
        colors={['#FFD700', '#00FFFF', '#00AEEF']}
        speed={0.5}
        connectionDistance={120}
        showConnections={true}
        particleTypes={['dot', 'circuit']}
      />
      
      {/* Background Pattern */}
      <div className="absolute inset-0 circuit-pattern opacity-30"></div>
      <div className="absolute inset-0 digital-grid opacity-20"></div>
      
      {/* Floating Particles */}
      <FloatingParticles 
        density={15}
        size="small"
        colors={['#FFD700', '#00FFFF']}
        className="opacity-40"
      />
      
      {/* Animated Background Elements */}
      <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-accent rounded-full animate-pulse"></div>
      <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-primary rounded-full animate-pulse delay-1000"></div>
      <div className="absolute bottom-1/4 left-1/3 w-1.5 h-1.5 bg-secondary rounded-full animate-pulse delay-500"></div>
      
      <div className="container mx-auto px-4 text-center relative z-10">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="w-40 h-40 rounded-full flex items-center justify-center tech-glow animate-pulse-glow p-8 bg-gradient-to-br from-primary/10 to-accent/5">
              <img 
                src={companyData.logo_url} 
                alt={`${companyData.name} Logo`} 
                className="w-full h-full object-contain object-center drop-shadow-2xl"
              />
            </div>
            <div className="absolute inset-0 w-40 h-40 border-2 border-primary/30 rounded-full animate-spin" style={{ animationDuration: '15s' }}></div>
            <div className="absolute inset-2 w-36 h-36 border border-accent/20 rounded-full animate-spin" style={{ animationDuration: '10s', animationDirection: 'reverse' }}></div>
          </div>
        </div>
        
        {/* Company Name */}
        <h1 className="font-orbitron text-6xl md:text-8xl font-black mb-6 bg-gradient-to-r from-primary via-accent to-secondary bg-clip-text text-transparent animate-float">
          {companyData.name}
        </h1>

        {/* Yellow Gold Accent*/}
        {/* <h1 className="font-orbitron text-6xl md:text-8xl font-black mb-6 text-primary animate-float">
          {companyData.name}
        </h1> */}
        
        {/* Tagline */}
        <p className="text-2xl md:text-4xl font-bold text-secondary mb-8 max-w-2xl mx-auto font-orbitron tracking-wider animate-pulse">
          {companyData.tagline}
        </p>
        
        {/* <div className="text-sm text-muted-foreground/70 mb-12 max-w-3xl mx-auto font-light tracking-wide">
          {companyData.description}
        </div> */}
        
        {/* CTA Button */}
        <Button 
          onClick={scrollToAbout}
          size="lg" 
          className="bg-primary text-primary-foreground hover:bg-primary/90 tech-glow font-orbitron text-lg px-8 py-4 mb-16 relative overflow-hidden group"
        >
          <span className="relative z-10">Explore Our Innovation</span>
          <div className="absolute inset-0 bg-gradient-to-r from-accent/20 to-secondary/20 transform translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
          <ChevronDown className="ml-2 h-5 w-5 animate-bounce" />
        </Button>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-primary rounded-full flex justify-center">
          <div className="w-1 h-3 bg-primary rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}